export function paginate<T>(items: readonly T[], page: number, pageSize: number) {
  if (!Number.isInteger(pageSize) || pageSize < 1) {
    throw new RangeError('pageSize must be a positive integer');
  }
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const currentPage = Number.isInteger(page) ? Math.min(Math.max(page, 1), totalPages) : 1;
  return {
    totalPages,
    currentPage,
    pageItems: items.slice((currentPage - 1) * pageSize, currentPage * pageSize),
  };
}
